import { FC } from 'react'
import { HelmetProvider } from 'react-helmet-async'

const withMetaData = (Component: FC) => {
  const helmetContext = {}
  return function WrappingComponent() {
    return (
      <HelmetProvider context={helmetContext}>
        <Component />
      </HelmetProvider>
    )
  }
}

export default withMetaData
